import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const colors = {
  trayModalLinearGradient: [Colors.white, Colors.veryLightPinkTwo],
  myPlanPrimaryCardStatus: Colors.secondary5,
  myPlanUsageValues: Colors.vfRed,
  myPlanIconBackground: Colors.mono3,
  myPlanUsgaeBlue: '#007C92'
};

export default colors;
